/**
 * Helpers for the New Relic browser agent
 * @module services/newrelic
 */

/**
 * Get the New Relic browser instance when the agent is present
 * @returns {Object|undefined} The New Relic browser agent
 */
export function getNewRelicInstance () {
  const { newrelic } = global
  return newrelic
}

/**
 * Record a custom browser event, ignored when the agent is unavailable
 * @param {String} name The page action name
 * @param {Object} [attributes={}] Flat attributes to record with the action
 */
export function addPageAction (name, attributes = {}) {
  const newrelic = getNewRelicInstance()
  if (!newrelic || typeof newrelic.addPageAction !== 'function') {
    return
  }
  newrelic.addPageAction(name, attributes)
}

/**
 * Record a handled error, ignored when the agent is unavailable
 * @param {Error} error The error to record
 * @param {Object} [attributes={}] Flat attributes to record with the error
 */
export function noticeError (error, attributes = {}) {
  const newrelic = getNewRelicInstance()
  if (!newrelic || typeof newrelic.noticeError !== 'function') {
    return
  }
  newrelic.noticeError(error, attributes)
}
